<template>
  <v-container>
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-data-iterator
      :items="items"
      item-key="name"
      :items-per-page="100"
      hide-default-footer
    >
      <template v-slot:header>
        <v-toolbar class="mt-2" color="grey lighten-4" flat outlined>
          <v-icon class="mr-3">mdi-magnify</v-icon>
          <v-toolbar-title>进行预定</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="style = 1"
            ><v-icon>mdi-format-list-bulleted</v-icon></v-btn
          >
          <v-btn icon @click="style = 2"><v-icon>mdi-grid-large</v-icon></v-btn>
        </v-toolbar>
        <v-text-field style="width:66.7%" class="ml-2" label="搜索" v-model="search"></v-text-field>
      </template>

      <template v-slot:default="props">
        <v-row style="width:100%" v-if="style==1">
          <v-simple-table style="width:100%">
            <tbody>
              <tr v-for="item in props.items" :key="item.Identity">
                <td style="width:10px">
                  <v-icon
                    v-show="item.Icon.indexOf('mdi-') >= 0"
                    class="ma-4"
                    style="font-size: 24px"
                    >{{ item.Icon }}</v-icon
                  >
                  <v-img
                    v-show="item.Icon.indexOf('mdi-') == -1"
                    contain
                    height="24px"
                    class="ma-4"
                    :src="item.Icon"
                  ></v-img>
                </td>
                <td style="text-align:left" @click="goTo(item.Identity)">{{ item.Name }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-row>
        <v-row v-if="style == 2">
          <v-col
            v-for="item in props.items"
            :key="item.Identity"
            cols="12"
            sm="6"
            md="4"
            lg="3"
          >
            <v-card @click="goTo(item.Identity)" style="width: 100%">
              <div class="mt-5 pt-5 pb-5">
                <v-icon
                  v-show="item.Icon.indexOf('mdi-') >= 0"
                  class="ma-4"
                  style="font-size: 120px"
                  >{{ item.Icon }}</v-icon
                >
                <v-img
                  v-show="item.Icon.indexOf('mdi-') == -1"
                  contain
                  height="120px"
                  class="ma-4"
                  :src="item.Icon"
                ></v-img>
                <p style="font-size: 18px">
                  {{ item.Name }}
                </p>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { eventTemplateService } from "@/api/event-template.service";
export default {
  name: "eventTemplateList",
  data: () => ({
    items: [],
    full: [],
    style: 1,
    search: '',
    isLoading: false,
  }),
  computed: {
    ...mapGetters(["userProfile"]),
  },
  watch:{
    search(val)
    {
      if (val)
      {
        this.items = this.full.filter(x=>x.Name.indexOf(val)!=-1)
      }
      else
      this.items = this.full
    },
    style(val)
    {
      localStorage.setItem('eventbooker-style', val)
    }
  },
  async mounted() {
    this.isLoading = true;
    //  if (!this.userProfile)
    //      await this.$store.dispatch('getUserProfile');

    var list = await eventTemplateService.getEventTemplates();
    this.items = list;
    this.full = JSON.parse(JSON.stringify(this.items));
    this.isLoading = false;

    let _style = localStorage.getItem('eventbooker-style');
    if (_style) this.style = _style;
  },
  methods: {
    goTo(id) {
      this.$router.push("/eventbooking/" + id);
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/EventTemplate/EventTemplateList.vue